import { Card, Col, Row, theme } from "antd";
import Title from "antd/es/typography/Title";

const AnalyticsCard = ({ value, style, label, icon, showIcon = true }) => {
  const {
    token: { colorPrimary },
  } = theme.useToken();

  return (
    <Card style={style} bordered={false} className="criclebox ">
      <div className="number">
        <Row align="middle" gutter={[24, 0]}>
          <Col xs={showIcon ? 18 : 24}>
            <span>{value}</span>
            <Title
              level={3}
              style={{
                whiteSpace: "nowrap",
              }}
            >
              {label}
            </Title>
          </Col>
          {showIcon && (
            <Col xs={6}>
              <div
                style={{
                  backgroundColor: colorPrimary,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="icon-box"
              >
                {icon}
              </div>
            </Col>
          )}
        </Row>
      </div>
    </Card>
  );
};

export default AnalyticsCard;
